import '../../../../../node_modules/jquery.maskedinput/src/jquery.maskedinput';

export default new class registerForm {
  constructor() {
    this.registerFormSelector = 'register__form';
    this.registerPhoneInput = 'register__phone';
    this.submitBtnSelector = 'register__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'register__success';
    this.successVisibleSelector = 'register__success_visible';
    this.preLoaderSelector = 'register__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.registerFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    const isValid = !form.classList.contains(this.inValidSelector);

    if (!isValid) return;

    $(form)
      .request('EokRegistration::onAjax', {
        complete: (res) => {
          this.showTooltip(res);
        },
      });
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('tooltip__error');
    } else {
      tooltip.classList.remove('tooltip__error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
